import { Gauge } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

/**
 * Telemetry rules (UI plan Phase 8, workstream 2).
 *
 * Its own file rather than a second export from `nav.ts`, matching how every
 * other slice does it: the shell imports nav modules eagerly, so one file per
 * entry keeps what lands in `initialJs` obvious.
 *
 * Gated on `equipment:read`, the same bit the rules API reads with — a nav
 * entry leading to a 403 is worse than no nav entry.
 */
export const telemetryRulesNav: NavEntry = {
  label: 'Sensor rules',
  icon: Gauge,
  path: '/telemetry-rules',
  permission: 'equipment:read',
  order: 20,
}
